<script setup lang="ts">
    import { formateCompanyReference } from '@/utils/functions';
// import { i } from 'node_modules/vite/dist/node/types.d-aGj9QkWt';
    import {Ref, onMounted, onUnmounted, ref, watch, StyleValue, defineAsyncComponent, onBeforeUnmount} from 'vue';


    const EyeOutline = defineAsyncComponent(() => import('vue-material-design-icons/EyeOutline.vue'))
    const EyeOffOutline = defineAsyncComponent(() => import('vue-material-design-icons/EyeOffOutline.vue'))

    // Props
    const props = withDefaults(defineProps<{
        id: string
        onInput?: Function
        onBlur?: Function
        onChange?: Function
        onFocus?: Function
        inputLabel?: string
        placeholder?: string
        type?: string
        errors?: string | null
        value: string
        classes?: any[]
        inputLabelClasses?: any[]
        style?: StyleValue
        disabled?: boolean
        maxlength?: string
        max?: string
        autocomplete?: string,
        isSiret?: boolean,
        userSizedClass?: boolean
    }>(), {
        type: 'text',
        errors: null,
        disabled: false,
        isSiret: false,
        userSizedClass: false,
    })

    // Emits
    const emit = defineEmits(['update:value','blur'])

    // Refs
    const passwordInputType = ref('password')
    const hidePassword = ref(true)
    const inputValue = ref(props.value)
    let classList: Ref<any> = ref(props.classes || [])
    let inputLabelClasses: Ref<any> = ref(props.inputLabelClasses || [])

    // Lifecycle Hooks
    onMounted(() => {
        if (props.errors) {
            classList.value.push('border-danger')
        }

        if (props.isSiret) {
            const inputElement = document.getElementById(props.id);
            if (inputElement) {
                inputElement.addEventListener('keypress', isNumber);
            }
        }

        if(props.userSizedClass) {
            inputLabelClasses.value.push('sized-text')
        } 
    })

    onUnmounted(() => {
        if (props.isSiret) {
            const inputElement = document.getElementById(props.id);
            if (inputElement) {
                inputElement.removeEventListener('keypress', isNumber);
            }
        }
    })

    // Watchers
    const unwatchProps = watch(() => props.value, (newValue) => {
        inputValue.value = newValue
    })

    // Functions
    const onInput = (event: any) => {
        let value = event.target.value
        if (props.isSiret) {
             value = formatSiret(value)
        }
        emit('update:value', value)
        if (props.onInput) {
            props.onInput()
        }
    }

    const formatSiret = (value: string) => {
        return formateCompanyReference(value);
    }
    

    const isNumber = (event: KeyboardEvent) => {
        const char = String.fromCharCode(event.keyCode)
        if (!/[0-9]/.test(char)) {
            event.preventDefault()
        }
    }

    function showPasswordToggle() {
        if (passwordInputType.value === 'password') {
            passwordInputType.value = 'text'
            hidePassword.value = false
        } else if (passwordInputType.value === 'text') {
            passwordInputType.value = 'password'
            hidePassword.value = true
        }
    }

    let onBlurHandlaer = (payload: FocusEvent) => {
        emit('blur', payload) 
        if (props.onBlur) {
            props.onBlur()
        }
    }

    const onFocusHandler = (event: FocusEvent) => {
        if (props.onFocus) {
            props.onFocus(event)
        }
    }

    onBeforeUnmount(() => {
        unwatchProps()
    })
</script>

<template>
    <div v-if="type === 'password'">
        <label class="form-label" :class="inputLabelClasses" v-if="inputLabel" :for="id" >
            {{ inputLabel }}
        </label>
        <div style="position: relative;">
            <input 
                :type="passwordInputType" 
                :id="id"
                :maxlength="maxlength"
                @blur="onBlurHandlaer"
                :value="value"
                :disabled="disabled"
                @input="onInput" 
                class="form-control text-start mb-0 input-custom"
                :class="[classList, { 'border-danger': errors }]"
                :style="style"
                :autocomplete="autocomplete"
                :placeholder="placeholder"/>
                
            <span 
                id="togglePassword" 
                @click="showPasswordToggle" 
                style="right: 10px; top: 14px; position: absolute; cursor: pointer; z-index: 100;">
                <eye-off-outline v-if="hidePassword" :size="18" />
                <eye-outline v-else :size="18" />
            </span>
        </div>
    </div>
    <div v-else style="position: relative;">
        <label  :class="inputLabelClasses"
            v-if="inputLabel" class="form-label" 
            :for="id">{{ inputLabel }}
        </label>
        <input
            :type="type"
            :id="id"
            :maxlength="maxlength"
            :max="max"
            v-model="inputValue"
            :disabled="disabled"
            @input="onInput"
            @blur="onBlurHandlaer"
            @focus="onFocusHandler"
            :autocomplete="autocomplete"
            class="form-control text-start mb-0"
            :class="[classList, { 'border-danger': errors }]"
            :style="style"
            :placeholder="placeholder">
    </div>
    
    <p class="mb-0 text-danger" v-if="errors">{{ errors }}</p>
</template>

<style scoped>
    @import url('@/assets/css/bootstrap-extended2.css');
    @import url('@/assets/css/bootstrap-extended.css');

    .form-check-input:checked {
        background-color: #FEB23C;
        border-color: #FEB23C;
    }

    .form-control{
        height: 50px !important;
        font-size: 16px;
    }
    
    .form-control:focus {
        border-color: #FEB23C;
        box-shadow: 0 0 0 0.02rem #FEB23C;
        /* padding-left: 1.5rem; */
        
    }
    .input-label-color {
        color: rgba(255, 255, 255, 0.76) !important;
    }

    .input-color {
        color: #233648 !important;
        
    }
    .form-control::placeholder {
    color: #23364895 !important;
}

    input[type="date"]::-webkit-datetime-edit-text,
    input[type="date"]::-webkit-datetime-edit-month-field,
    input[type="date"]::-webkit-datetime-edit-day-field,
    input[type="date"]::-webkit-datetime-edit-year-field {
        color: #23364895;
    }

    input[type="date"]:focus::-webkit-datetime-edit-text,
    input[type="date"]:focus::-webkit-datetime-edit-month-field,
    input[type="date"]:focus::-webkit-datetime-edit-day-field,
    input[type="date"]:focus::-webkit-datetime-edit-year-field {
        color: #233648;
    }
   
    
</style>
